import script from "./GroupNewsLink.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupNewsLink.vue?vue&type=script&setup=true&lang=js"

import "./GroupNewsLink.vue?vue&type=style&index=0&id=8f1f9346&lang=css"

const __exports__ = script;

export default __exports__